import request from '@/utils/request'

let Vehicle_brandApi = {

  /*车辆品牌列表*/
  list(data) {
    return request._post('/shop/plus.vehicle_brand.Index/index', data);
},
/*添加车辆品牌*/
add(data) {
    return request._post('/shop/plus.vehicle_brand.Index/add', data);
},
/*修改车辆品牌*/
edit(data) {
    return request._post('/shop/plus.vehicle_brand.Index/edit', data);
},
/*删除车辆品牌*/
del(data) {
    return request._post('/shop/plus.vehicle_brand.Index/del', data);
},
/*车辆品牌详情*/
detail(data) {
  return request._post('/shop/plus.vehicle_brand.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.vehicle_brand.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.vehicle_brand.Setting/getSetting', data, errorback);
    },
}
export default Vehicle_brandApi;



// WEBPACK FOOTER //
// ./src/api/vehicle_brand.js